export default __webpack_public_path__ + "static/anuMehta3-62a5dca892b16bd7d2eb20bb2b4139d2.jpg";